import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, MessageSquare, Vote, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/logger";

const Badge = ({ icon: Icon, value, color }) => (
  <span className="flex items-center gap-1 font-mono text-[0.7rem]" style={{ color }}>
    <Icon className="h-3 w-3" strokeWidth={1.5} /> {value}
  </span>
);

export const TrendingStrip = () => {
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/trending-social?limit=6");
        setTopics(data);
      } catch (err) {
        logError("Failed to load trending strip:", err);
      }
    })();
  }, []);

  if (topics.length === 0) return null;

  return (
    <section className="border-b border-[#333] bg-[#0d0d0d]" data-testid="trending-strip">
      <div className="mx-auto max-w-7xl px-6 py-6">
        <div className="mb-4 flex items-center gap-2 text-[#D92D20]">
          <TrendingUp className="h-4 w-4" strokeWidth={1.5} />
          <span className="meta-label">Trending Now · Most engaged on our channels</span>
        </div>
        <div className="flex snap-x gap-3 overflow-x-auto pb-2" data-testid="trending-strip-list">
          {topics.map((t) => {
            const a = t.votes?.a || 0;
            const b = t.votes?.b || 0;
            return (
              <button
                key={t.id}
                data-testid={`trending-card-${t.id}`}
                onClick={() => navigate(`/topic/${t.id}`)}
                className="group w-64 shrink-0 snap-start panel p-4 text-left transition-colors hover:border-[#D92D20]/60"
              >
                <div className="meta-label mb-2 text-[#737373]">{t.category}</div>
                <div className="mb-3 line-clamp-2 font-heading text-base leading-tight text-white group-hover:text-[#FBBF24]">
                  {t.title}
                </div>
                <div className="flex items-center gap-3 border-t border-[#222] pt-2">
                  <Badge icon={Eye} value={t.views || 0} color="#FBBF24" />
                  <Badge icon={Vote} value={a + b} color="#3B82F6" />
                  <Badge icon={MessageSquare} value={t.comment_count || 0} color="#22C55E" />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
